<script>
import { Line } from 'vue-chartjs';
import 'chartjs-adapter-luxon';

export default {
  mixins: [Line],
  props: {
    isActive: {
      type: Boolean,
      default() {
        return false;
      },
    },
    chartdata: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          lineTension: 1,
          legend: {
            onClick: () => {},
            labels: {
              defaultFontFamily: 'Roboto',
            },
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  displayFormats: {
                    hour: 'H:mm',
                    quarter: 'M YYYY',
                    day: 'D.M',
                  },
                },
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                id: 'A',
                type: 'linear',
                position: 'left',
                gridLines: {
                  display: false,
                },
                ticks: {},
              },
              {
                id: 'B',
                type: 'linear',
                position: 'left',
                gridLines: {
                  display: false,
                },
                ticks: {},
              },
            ],
          },
          tooltips: {
            mode: 'index',
            callbacks: {
              label(tooltipItem, data) {
                // Get the dataset label.
                const label = data.datasets[tooltipItem.datasetIndex].label;

                // Format the y-axis value.
                const value =data.datasets[tooltipItem.datasetIndex].customFormatter(tooltipItem.yLabel);

                return `${label}: ${value}`;
              }
            }
          }
        };
      },
    },
    time: {
      type: String,
      default: '',
    },
  },

  watch: {
    chartdata() {
      this.renderChart(this.chartdata, this.options);
    },
  },

  mounted() {
    this.renderChart(this.chartdata, this.options);
  },

  beforeRouteUpdate(to, from, next) {
    this.renderChart(this.chartdata, this.options);

    next();
  },
};
</script>

<style lang="scss" scoped>
canvas {
  max-width: 100% !important;
  display: inline;
  // width: 100% !important;
  // height: auto !important;
}
</style>
